const Cookie = () => {
    return (
        <div className="flex text-start flex-col margin-x py-10">
            <>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#000000",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        COOKIE POLICY
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        The cookie policy of Foodb
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        outlines the different types of cookies that may be used in relation to the Website
                        https://order.foodb.co.uk, owned and administered by us, through which you have access to this
                        Cookie Policy (the "
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Website
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        "), as well as information on how you can control them.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        What are actually cookies?
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Cookies are small files, which are used for access to the Internet, that are stored on the
                        computer, the mobile device, the tablet or other equipment of a given User.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Cookies are installed through a request by the server of a given web page to your web browser
                        (i.e. Internet Explorer, Chrome, Safari, Mozilla) and are completely "passive" (they do not
                        contain any software, viruses or spyware and do not have access to the information of the User
                        hardware).
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        What are cookies used for?
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Cookies are used in a way, allowing the Website to function better and more efficiently. Cookies
                        are needed in order for you to browse the Website and to use their services and functionalities.
                        Without those essential cookies, our Website will not function as fluently as we would like them
                        to and we might not be able to provide you with certain services or features.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Cookies are also used in order to prepare anonymous statistics, which aid us at understanding,
                        how a given user prefers to use our Website, allowing us to improve its structure and contents,
                        without identifying the user. The Foodb
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Website may also use certain Wordpress features, software such as Google Analytics, Google
                        Adsense or Google Adwords, Facebook, Twitter, Google+ or other social media “like” buttons or
                        plugins, which contain cookies.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        What types of cookies do we use?
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We use two types of cookies – for the user session and fixed ones. The former ones are temporary
                        files, which remain on the device of the User until the end of his/her user session or until
                        closing the web browser. The fixed files remain on the device of the User for the period,
                        specified in the cookies themselves or until deleted by the User.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "8pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        What are the purposes for which we use cookies?
                    </span>
                </p>
                <div dir="ltr" style={{ marginLeft: "0pt" }} align="left">
                    <table style={{ border: "none", borderCollapse: "collapse" }}>
                        <tbody>
                            <tr style={{ height: "63pt" }}>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Processes
                                        </span>
                                    </p>
                                </td>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            textAlign: "justify",
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Intended to make the Website work in the way you expect. For example, we use
                                            a cookie that tells us whether you have already signed up for a User
                                            Account.
                                        </span>
                                    </p>
                                </td>
                            </tr>
                            <tr style={{ height: "81pt" }}>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Authentication, Security and Compliance
                                        </span>
                                    </p>
                                </td>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            textAlign: "justify",
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Intended to prevent fraud, protect your data from unauthorized parties, and
                                            comply with legal requirements. For example, we use cookies to determine if
                                            you are logged in your User Account.
                                        </span>
                                    </p>
                                </td>
                            </tr>
                            <tr style={{ height: "81pt" }}>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Preferences
                                        </span>
                                    </p>
                                </td>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            textAlign: "justify",
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Intended to remember information about how you prefer the services to behave
                                            and look. For example, we use a cookie that tells us whether you have
                                            declined to allow us to use your phone’s geolocation data.
                                        </span>
                                    </p>
                                </td>
                            </tr>
                            <tr style={{ height: "81pt" }}>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Notifications
                                        </span>
                                    </p>
                                </td>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            textAlign: "justify",
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Intended to allow or prevent notices of information or options that we think
                                            could improve your use of the Service. For example, we use a Cookie that
                                            stops us from showing you the signup notification if you have already seen
                                            it.
                                        </span>
                                    </p>
                                </td>
                            </tr>
                            <tr style={{ height: "81pt" }}>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Analytics
                                        </span>
                                    </p>
                                </td>
                                <td
                                    style={{
                                        borderLeft: "solid #000000 0.68181825pt",
                                        borderRight: "solid #000000 0.68181825pt",
                                        borderBottom: "solid #000000 0.68181825pt",
                                        borderTop: "solid #000000 0.68181825pt",
                                        verticalAlign: "top",
                                        
                                        padding: "0pt 5pt 0pt 5pt",
                                        overflow: "hidden",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    <p
                                        dir="ltr"
                                        style={{
                                            lineHeight: "1.8857142857142857",
                                            marginLeft: "5pt",
                                            textAlign: "justify",
                                            marginTop: "0pt",
                                            marginBottom: "8pt",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12pt",
                                                fontFamily: "Arial,sans-serif",
                                                color: "#777777",
                                                backgroundColor: "transparent",
                                                fontWeight: 400,
                                                fontStyle: "normal",
                                                fontVariant: "normal",
                                                textDecoration: "none",
                                                verticalAlign: "baseline",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >
                                            Intended to help us understand how visitors use the services. For example,
                                            we use a Cookie that tells us how our search suggestions correlate with your
                                            interactions with the search page.
                                        </span>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Do cookies contain personal data?
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        On their own, cookies do not require personal information in order to be used and most often,
                        they do not identify internet Users. The personal data, collected during the usage of cookies
                        can only be gathered in order to ease the use of the services by the User. This data is
                        encrypted in such a way that it does not allow unauthorized persons to gain access it.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Deleting the cookies
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        In general, applications for access to web pages (web- or mobile browsers) allow the storage of
                        cookies by default. These settings may be changed in such a way that the automatic
                        administration of cookies is blocked by the web browser or that the User would be informed each
                        time when cookies are sent to his/her device. Detailed information about the options and
                        management of cookies may be found in the settings of the Web Browser. Limiting the usage of
                        cookies may affect some of the features of the Website.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Security and confidentiality
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Cookies are NOT viruses. They take the form of simple text. They are not made out of code and
                        cannot therefore be executed or execute themselves alone. Consequently, they may not be
                        duplicated or copied into other networks in order to get started and copied once more. Since
                        cookies cannot perform those functions, they cannot be regarded as viruses.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Most often, browsers have built-in privacy settings, which provide different levels for the
                        acceptance of cookies, the period of their validity and their automatic deletion after a User
                        has visited a given website.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Advice on secure and responsible surfing, using cookies
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Thanks to their flexibility and the fact that many of the most visited and biggest websites use
                        cookies, their use is almost inevitable. Deactivating cookies will not allow the access of a
                        given user to many of the most commonly used websites, including YouTube, Yahoo, Gmail and
                        others.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "8pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Here is some advice, which can
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#333333",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;ensure safe surfing, but with the help of cookies:
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        ·
                    </span>
                    <span
                        style={{
                            fontSize: "6.999999999999999pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Personalize your cookie browser settings, in order to create an adequate level of protection
                        from the use of cookies.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        ·
                    </span>
                    <span
                        style={{
                            fontSize: "6.999999999999999pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If you are the only person who uses the computer, you may set longer terms for expiration of the
                        storage of the browsing history and access to personal data.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        ·
                    </span>
                    <span
                        style={{
                            fontSize: "6.999999999999999pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If you share your computer access with somebody, you may set your browser settings to delete the
                        surfing data every time you close your web browser.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "8pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "10pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        ·
                    </span>
                    <span
                        style={{
                            fontSize: "6.999999999999999pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Ensure that your browser is always up to date. Many of the attacks, based on cookies, are
                        realized when exploiting the weak spots of old and non-updated versions of the web browsers.
                        Cookies are everywhere and they may not be circumvented if you would like to enjoy your access
                        to the best and biggest websites on the Internet.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "18pt",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "8pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        It is possible that you set your browser in a way that does not allow for cookies to be accepted
                        anymore or you can set your browser to accept cookies only from certain websites. All modern
                        browsers offer the option to change cookie settings.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#333333",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;This includes computer browsers, as well as mobile device browsers. These settings can be
                        found in the "options" menu or the "preferences" menu of your browser. In order to find those
                        settings, you can also use the links below or use the "help" menu of your browser for more
                        information.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <a href="http://support.microsoft.com/kb/196955" style={{ textDecoration: "none" }}>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            Cookie settings in Internet Explorer
                        </span>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            <br />
                        </span>
                    </a>
                    <a
                        href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies"
                        style={{ textDecoration: "none" }}
                    >
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            Cookie settings in Firefox
                        </span>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            <br />
                        </span>
                    </a>
                    <a href="https://support.google.com/chrome/answer/95647?hl=en" style={{ textDecoration: "none" }}>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            Cookie settings in Chrome
                        </span>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            <br />
                        </span>
                    </a>
                    <a href="http://support.apple.com/kb/PH5042" style={{ textDecoration: "none" }}>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            Cookie settings in Safari
                        </span>
                    </a>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        For setting third party cookies, you may use the following website:
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <a href="http://www.youronlinechoices.com/" style={{ textDecoration: "none" }}>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            http://www.youronlinechoices.com
                        </span>
                    </a>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Useful links
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        textAlign: "justify",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If you want to find more about cookies and what are they used for, we recommend you the
                        following links:
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        
                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 8pt 0pt",
                    }}
                >
                    <a href="http://www.microsoft.com/info/cookies.mspx" style={{ textDecoration: "none" }}>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            Microsoft Cookies guide
                        </span>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#954f72",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            <br />
                        </span>
                    </a>
                    <a href="http://www.allaboutcookies.org/" style={{ textDecoration: "none" }}>
                        <span
                            style={{
                                fontSize: "12pt",
                                fontFamily: "Arial,sans-serif",
                                color: "#0563c1",
                                backgroundColor: "transparent",
                                fontWeight: 400,
                                fontStyle: "normal",
                                fontVariant: "normal",
                                textDecoration: "underline",
                                WebkitTextDecorationSkip: "none",
                                textDecorationSkipInk: "none",
                                verticalAlign: "baseline",
                                whiteSpace: "pre-wrap",
                            }}
                        >
                            All About Cookies
                        </span>
                    </a>
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Arial,sans-serif",
                            color: "#333333",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p>
                    <br />
                </p>
                <p>
                    <br />
                </p>
            </>
        </div>
    );
};
export default Cookie;
